__turbopack_context__.v({
  "buttons": "K7Spaq_buttons",
  "choiceFields": "K7Spaq_choiceFields",
  "choices": "K7Spaq_choices",
  "error": "K7Spaq_error",
  "feedbackForm": "K7Spaq_feedbackForm",
  "guestHome": "K7Spaq_guestHome",
  "guestToolbar": "K7Spaq_guestToolbar",
  "partial": "K7Spaq_partial",
  "progress": "K7Spaq_progress",
  "responseActions": "K7Spaq_responseActions",
});
